/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cna_Field_NumbersInputs */

const en_cna_field_numbers = /** @type {(inputs: Cna_Field_NumbersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phone numbers called`)
};

const ja_cna_field_numbers = /** @type {(inputs: Cna_Field_NumbersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`発信した電話番号`)
};

const fr_cna_field_numbers = /** @type {(inputs: Cna_Field_NumbersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numéros de téléphone appelés`)
};

const de_cna_field_numbers = /** @type {(inputs: Cna_Field_NumbersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angerufene Telefonnummern`)
};

/**
* | output |
* | --- |
* | "Phone numbers called" |
*
* @param {Cna_Field_NumbersInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const cna_field_numbers = /** @type {((inputs?: Cna_Field_NumbersInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cna_Field_NumbersInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cna_field_numbers(inputs)
	if (locale === "ja") return ja_cna_field_numbers(inputs)
	if (locale === "fr") return fr_cna_field_numbers(inputs)
	return de_cna_field_numbers(inputs)
});